module.exports = __webpack_public_path__ + "img/store-item-placeholder.e0a4ee23.webp";